import axiosInstance from '../app/axios';

export const categoryAPI = {
  getAll: async () => {
    const response = await axiosInstance.get('/categories');
    return response.data;
  },

  getProductsBySlug: async (slug) => {
    const response = await axiosInstance.get(`/categories/${slug}/products`);
    return response.data;
  },
};

export default categoryAPI;